(function () {
  const sections = document.querySelectorAll(".koffi-ba");
  if (!sections.length) return;

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function setPos(root, percent) {
    const p = clamp(percent, 0, 100);

    const before = root.querySelector("[data-ba-before]");
    const divider = root.querySelector("[data-ba-divider]");
    const handle = root.querySelector("[data-ba-handle]");
    const range = root.querySelector("[data-ba-range]");

    if (before) before.style.clipPath = `inset(0 ${100 - p}% 0 0)`;
    if (divider) divider.style.left = `${p}%`;
    if (handle) handle.style.left = `${p}%`;
    if (range) range.value = String(Math.round(p));
  }

  sections.forEach((section) => {
    const root = section.querySelector("[data-ba]");
    if (!root) return;

    const range = root.querySelector("[data-ba-range]");
    const handle = root.querySelector("[data-ba-handle]");

    const start = Number(section.dataset.start || 50);
    setPos(root, Number.isFinite(start) ? start : 50);

    // Range input (keyboard / accessibility)
    if (range) {
      range.addEventListener("input", () => {
        setPos(root, Number(range.value || 50));
      });
    }

    // Pointer drag
    let dragging = false;

    function updateFromPointer(clientX) {
      const rect = root.getBoundingClientRect();
      const x = clamp(clientX - rect.left, 0, rect.width);
      const p = (x / rect.width) * 100;
      setPos(root, p);
    }

    function onDown(e) {
      dragging = true;
      handle && handle.setPointerCapture && handle.setPointerCapture(e.pointerId);
      updateFromPointer(e.clientX);
    }

    function onMove(e) {
      if (!dragging) return;
      updateFromPointer(e.clientX);
    }

    function onUp() {
      dragging = false;
    }

    // Allow dragging from handle or anywhere on the frame
    root.addEventListener("pointerdown", onDown, { passive: true });
    root.addEventListener("pointermove", onMove, { passive: true });
    window.addEventListener("pointerup", onUp, { passive: true });
  });
})();
